import React, { useState, useEffect } from "react";
import axios from "axios";
import { API, colors } from "../shared/constants";
import { styles, inputStyle, labelStyle } from "../shared/styles";
import { SimpleModal } from "../shared/SimpleModal";

export function EFSMSettings() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [categoryName, setCategoryName] = useState("");
  const [requiresFlowTest, setRequiresFlowTest] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [hovered, setHovered] = useState(null);
  const loadCategories = () => {
    axios
      .get(`${API}/asset-categories/`)
      .then((res) => {
        setCategories(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };
  useEffect(() => {
    loadCategories();
  }, []);
  const openAdd = () => {
    setEditingCategory(null);
    setCategoryName("");
    setRequiresFlowTest(false);
    setError("");
    setShowModal(true);
  };
  const openEdit = (c, e) => {
    e.stopPropagation();
    setEditingCategory(c);
    setCategoryName(c.name);
    setRequiresFlowTest(!!c.requires_flow_test);
    setError("");
    setShowModal(true);
  };
  const handleSave = async () => {
    if (!categoryName.trim()) {
      setError("Name is required.");
      return;
    }
    setSaving(true);
    setError("");
    try {
      if (editingCategory) {
        await axios.patch(`${API}/asset-categories/${editingCategory.id}/`, {
          name: categoryName,
          requires_flow_test: requiresFlowTest,
        });
      } else {
        await axios.post(`${API}/asset-categories/`, {
          name: categoryName,
          requires_flow_test: requiresFlowTest,
        });
      }
      setShowModal(false);
      loadCategories();
    } catch (e) {
      setError("Something went wrong.");
    }
    setSaving(false);
  };
  return (
    <div>
      <div style={styles.topbar}>
        <div style={styles.pageTitle}>Fire Safety Measures</div>
      </div>
      <div style={styles.content}>
        <div style={styles.card}>
          <div style={{ ...styles.searchBar, justifyContent: "flex-end" }}>
            <button style={styles.addButton} onClick={openAdd}>
              + Add Measure
            </button>
          </div>
          <div
            style={{ ...styles.tableHeader, gridTemplateColumns: "2fr 80px" }}
          >
            <div>Measure Name</div>
            <div></div>
          </div>
          {loading ? (
            <div style={styles.loading}>Loading...</div>
          ) : categories.length === 0 ? (
            <div style={styles.loading}>No measures yet.</div>
          ) : (
            categories.map((cat) => (
              <div
                key={cat.id}
                style={{
                  ...styles.tableRow(hovered === cat.id),
                  gridTemplateColumns: "2fr 80px",
                }}
                onMouseEnter={() => setHovered(cat.id)}
                onMouseLeave={() => setHovered(null)}
              >
                <div style={{ fontWeight: "500", color: colors.text }}>
                  {cat.name}
                </div>
                <div>
                  <button
                    onClick={(e) => openEdit(cat, e)}
                    style={{
                      backgroundColor: colors.blue,
                      color: colors.white,
                      border: "none",
                      padding: "4px 14px",
                      borderRadius: "12px",
                      fontSize: "12px",
                      fontWeight: "600",
                      cursor: "pointer",
                    }}
                  >
                    Edit
                  </button>
                </div>
              </div>
            ))
          )}
          <div style={styles.count}>
            {categories.length} Measure{categories.length !== 1 ? "s" : ""}
          </div>
        </div>
      </div>
      {showModal && (
        <SimpleModal
          title={
            editingCategory
              ? `Edit: ${editingCategory.name}`
              : "New Fire Safety Measure"
          }
          onClose={() => setShowModal(false)}
          onSave={handleSave}
          saving={saving}
          error={error}
        >
          <div>
            <label style={labelStyle}>Measure Name *</label>
            <input
              style={inputStyle}
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
              placeholder="e.g. Emergency & Exit Lighting"
              autoFocus
            />
          </div>
          <div style={{ marginTop: "16px" }}>
            <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "13px", color: colors.text, cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={requiresFlowTest}
                onChange={(e) => setRequiresFlowTest(e.target.checked)}
              />
              Requires Fire Hose Reel Flow Test
            </label>
            <div style={{ fontSize: "12px", color: colors.slate, marginTop: "4px", marginLeft: "24px" }}>
              Annual inspections covering this category will automatically
              get a Flow Test job created (AS 1851 / AS 2441 compliance).
            </div>
          </div>
        </SimpleModal>
      )}
    </div>
  );
}
